import UserValidation from './uservalidation-view';

export default UserValidation;
